module.exports = __webpack_public_path__ + "static/media/as6cr538.f4994e42.png";